import { render, staticRenderFns } from "./NewModifyCourse.vue?vue&type=template&id=5dbde34c&scoped=true"
import script from "./NewModifyCourse.vue?vue&type=script&lang=js"
export * from "./NewModifyCourse.vue?vue&type=script&lang=js"
import style0 from "./NewModifyCourse.vue?vue&type=style&index=0&id=5dbde34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbde34c",
  null
  
)

export default component.exports